import { useTranslation } from "react-i18next";
import MenuBarComponent from "../Components/MenuBarComponent"
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../Contexts/AuthContext";
import { deleteEventService, listEventsByCreatedByService } from "../Service/EventService";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";

function EventsHome() {
    
    const { t } = useTranslation('events');
    const navigate = useNavigate()
    const {userAuth} = useContext(AuthContext)
    const [events, setEvents] = useState()

    useEffect(()=>{
        listEvents()
    },[])

    const listEvents = () =>{
        userAuth?.user?.access_key && listEventsByCreatedByService(userAuth?.user?.access_key).then((res)=>{
            setEvents(res)
        })
    }

    const handleDelete = (access_key, name) => {
        confirmDialog({
            message: t('events_home_delete_message') + name + '?',
            header: t('events_home_delete_confirmation'),
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept:()=>{
                deleteEventService(access_key).then((res)=>{
                    if (res === true) {
                        toast.success(t('event_home_deleted_message'))
                        listEvents()
                    }
                })
            },
            reject:()=>{}
        });
    }



    return (
        <div className="flex flex-column gap-4">
            <MenuBarComponent />
            <ConfirmDialog />
            <div className="flex justify-content-between p-4">
                <div className="text-2xl md:text-4xl font-bold">
                    {t('events_home_title')}
                </div>
                <Button label={t('events_home_add_button')} icon={'pi pi-plus'} onClick={()=>navigate('/app/events_form')}/>
            </div>
            <div className="flex flex-column gap-2 px-4">
                {events && <div>
                    {events.map((event, key)=>(
                        <div key={key} className={`flex flex-column gap-2 p-2 border-round ${key%2 ? 'bg-gray-200' : ''}`}>
                            <div className="flex justify-content-between gap-2">
                                <span className="text-lg md:text-xl font-bold">{event.title}</span>
                                <div className="flex gap-2">
                                    <Button icon='pi pi-pencil' onClick={()=>navigate('/app/events_form/'+event.access_key)}/>
                                    <Button icon='pi pi-trash' severity="danger" onClick={()=>handleDelete(event.access_key, event.title)} />
                                </div>
                            </div>
                            <div className="flex justify-content-between gap-2">
                                <div className="flex flex-column gap-2">
                                    <div className="flex flex-column gap-1">
                                        <span className="font-bold">{t('events_home_date_start_title')}</span>
                                        <span>{new Date(event.date_start).toLocaleDateString()}</span>
                                    </div>
                                    <div className="flex flex-column gap-1">
                                        <span className="font-bold">{t('events_home_time_start_title')}</span>
                                        <span>{new Date(new Date().toLocaleDateString() +' '+ event.time_start).toLocaleTimeString()}</span>
                                    </div>
                                </div>

                                <div className="flex flex-column gap-2">
                                    <div className="flex flex-column gap-1">
                                        <span className="font-bold">{t('events_home_date_end_title')}</span>
                                        <span>{new Date(event.date_end).toLocaleDateString()}</span>
                                    </div>
                                    <div className="flex flex-column gap-1">
                                        <span className="font-bold">{t('events_home_time_end_title')}</span>
                                        <span>{new Date(new Date().toLocaleDateString() +' '+ event.time_end).toLocaleTimeString()}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>}
            </div>
        </div>
    )
}

export default EventsHome